import { useEffect, useRef, useState } from "react";
import '../css/JustifiedGallery.css'

export default function JustifiedGallery({
  viewOn,
  setOverlayState,
  images,
  targetRowHeight = 220,
  gap = 6,
}) {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [loadedImages, setLoadedImages] = useState([]);

  // Get the actual width of the gallery
  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  // Load images and get their natural dimensions
  useEffect(() => {
    let cancelled = false;

    Promise.all(
      images.map(
        (src) =>
          new Promise((resolve) => {
            const img = new Image();

            img.onload = () =>
              resolve({
                src,
                ratio: img.naturalWidth / img.naturalHeight,
              });

            img.src = src;
          })
      )
    ).then((result) => {
      if (!cancelled) setLoadedImages(result);
    });

    return () => {
      cancelled = true;
    };
  }, [images]);

  const rows = [];
  let row = [];
  let ratioTotal = 0;

  for (const image of loadedImages) {
    row.push(image);
    ratioTotal += image.ratio;

    const expectedWidth =
      ratioTotal * targetRowHeight +
      (row.length - 1) * gap;

    if (expectedWidth >= width && width > 0) {
      rows.push({ images: row, ratioTotal });
      row = [];
      ratioTotal = 0;
    }
  }

  // Add the final row
  if (row.length) {
    rows.push({
      images: row,
      ratioTotal,
      last: true,
    });
  }

  return (
    <div ref={containerRef} className="justified-gallery">
      {rows.map((row, rowIndex) => {
        const totalGap = (row.images.length - 1) * gap;

        // row width shenanigans
        const rowHeight = row.last
          ? targetRowHeight
          : (width - totalGap) / row.ratioTotal;

        return (
          <div
            className="gallery-row"
            key={rowIndex}
            style={{
              height: rowHeight,
              gap,
            }}
          >
            {row.images.map((image) => (
              <img 
                onClick={() => setOverlayState(!viewOn, image.src)}
                key={image.src}
                src={image.src}
                alt=""
                style={{
                  width: rowHeight * image.ratio,
                  height: rowHeight,
                }}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}